import * as consts from 'redux/constants';
import { PREVIEW_POSSIBLE_VIEWS } from 'components/containers/Preview/consts';

const initialState = {
  ABTesting: null,
  pageToken: null,
  merchant: {
    orgId: null,
    website: null,
    logo: null,
    logo_base64: null,
    color: null,
    language: null,
    alias: null,
    customerSupport: {
      phoneNumber: null,
      email: null,
      url: null
    }
  },
  geo: {
    geoCountry: null,
    region: null
  },
  loader: {
    loading: false,
    loadingProps: null
  },
  modal: {
    type: null,
    props: {}
  },
  configData: {},
  sdkParams: {},
  customStyles: null,
  isMobile: false,
  isSdk: false,
  isDemo: false,
  isPreview: false,
  previewConfig: {
    categories: [],
    btnColor: null,
    view: null,
    ctaText: null,
    logo: null,
    alias: null,
    language: null,
    previewApplePay: null,
    previewGooglePay: null
  },
  embedded: false,
  sessionId: null,
  paymentAlert: {
    shown: false
  },
  featureFlags: {},
  pageType: '',
  userFirstPageUrl: '',
  banner: {
    props: {}
  },
  commonPageData: {}
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case consts.SET_AB_TESTING:
      return {
        ...state,
        ABTesting: action.payload
      };
    case consts.SET_PAGE_TOKEN:
      return {
        ...state,
        pageToken: action.payload
      };
    case consts.SET_IS_LOADING:
      return {
        ...state,
        loader: action.payload
      };
    case consts.SET_SESSION_ID:
      return {
        ...state,
        sessionId: action.payload.sessionId
      };
    case consts.SET_CONFIG_DATA:
      return { ...state, configData: action.payload };
    case consts.SET_MERCHANT_DATA:
      return { ...state, merchant: { ...state.merchant, ...action.payload } };
    case consts.SET_GEO_DATA:
      return { ...state, geo: action.payload };
    case consts.SET_SDK_PARAMS: {
      return {
        ...state,
        sdkParams: { ...state.sdkParams, ...action.payload },
        isSdk: true,
        embedded: action.meta.embedded
      };
    }
    case consts.SET_CUSTOM_STYLES:
      return {
        ...state,
        customStyles: action.payload
      };
    case consts.SET_IS_MOBILE:
      return { ...state, isMobile: action.payload };
    case consts.SET_IS_DEMO:
      return { ...state, isDemo: action.payload };
    case consts.SET_IS_PREVIEW:
      return { ...state, isPreview: action.payload };
    case consts.SET_PREVIEW_CONFIG: {
      const isSdk = state.isSdk || action.payload?.view === PREVIEW_POSSIBLE_VIEWS.sdk;

      return {
        ...state,
        isSdk,
        previewConfig: { ...state.previewConfig, ...action.payload }
      };
    }
    case consts.SHOW_MODAL:
      return {
        ...state,
        modal: { type: action.payload.type, props: action.payload.props }
      };
    case consts.UPDATE_MODAL_GENERAL_PROPS:
      return {
        ...state,
        modal: {
          ...state.modal,
          props: {
            ...state.modal.props,
            generalProps: {
              ...state.modal.props.generalProps,
              ...action.payload.props
            }
          }
        }
      };
    case consts.UPDATE_MODAL_PRIMARY_BUTTON_PROPS:
      return {
        ...state,
        modal: {
          ...state.modal,
          props: {
            ...state.modal.props,
            generalProps: {
              ...state.modal.props.generalProps,
              primaryButtonProps: {
                ...state.modal.props.generalProps.primaryButtonProps,
                ...action.payload.props
              }
            }
          }
        }
      };
    case consts.UPDATE_MODAL_SECONDARY_BUTTON_PROPS:
      return {
        ...state,
        modal: {
          ...state.modal,
          props: {
            ...state.modal.props,
            generalProps: {
              ...state.modal.props.generalProps,
              secondaryButtonProps: {
                ...state.modal.props.generalProps.secondaryButtonProps,
                ...action.payload.props
              }
            }
          }
        }
      };
    case consts.HIDE_MODAL:
      return {
        ...state,
        modal: { type: null, props: {} }
      };
    case consts.SET_PAYMENT_ALERT_SHOWN: {
      const { shown } = action.payload;
      return {
        ...state,
        paymentAlert: {
          ...state.paymentAlert,
          shown
        }
      };
    }
    case consts.SET_FEATURE_FLAGS: {
      const receivedFeatureFlags = action.payload;

      return {
        ...state,
        featureFlags: {
          ...state.featureFlags,
          ...receivedFeatureFlags
        }
      };
    }
    case consts.DISABLE_CARD_ABSTRACTION: {
      return {
        ...state,
        featureFlags: {
          ...state.featureFlags,
          card_abstraction: false
        }
      };
    }
    case consts.SET_PAGE_TYPE: {
      const { pageType } = action.payload;

      return {
        ...state,
        pageType: pageType || ''
      };
    }
    case consts.SET_USER_FIRST_PAGE_URL: {
      const userFirstPageUrl = action.payload;

      return {
        ...state,
        userFirstPageUrl: userFirstPageUrl || ''
      };
    }
    case consts.SHOW_BANNER:
      return {
        ...state,
        banner: { props: action.payload.props }
      };
    case consts.HIDE_BANNER:
      return {
        ...state,
        banner: { props: {} }
      };
    case consts.SET_COMMON_PAGE_DATA:
      return { ...state, commonPageData: action.payload };
    default:
      return state;
  }
};

export default reducer;
